import { Button } from "@ui/components";
import { cn } from "@ui/lib/utils";
import { createContext, type ReactNode, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useFetcher } from "react-router";

export interface LanguageSwitchProviderProps {
  children: ReactNode;
}

export interface LanguageSwitchContextValue {
  availableLocaleOptions: { label: string; locale: string }[];
}

const defaultContextValue = {
  availableLocaleOptions: [
    { label: "EN", locale: "en" },
    { label: "PL", locale: "pl" },
  ],
};

const LanguageSwitchContext =
  createContext<LanguageSwitchContextValue>(defaultContextValue);

export function LanguageSwitchProvider(props: LanguageSwitchProviderProps) {
  return (
    <LanguageSwitchContext.Provider value={defaultContextValue}>
      {props.children}
    </LanguageSwitchContext.Provider>
  );
}

export function useLanguageSwitchContext() {
  return useContext(LanguageSwitchContext);
}

export interface LanguageSwitchButtonProps {
  locale: string;
  label: string;
}

export function LanguageSwitchButton(props: LanguageSwitchButtonProps) {
  const fetcher = useFetcher();
  const { i18n } = useTranslation();
  return (
    <fetcher.Form method="POST" action="/change-language">
      <input hidden readOnly name="locale" value={props.locale} />
      <Button
        className={cn("p-0 h-8 w-8 rounded-[0.5rem]", {
          "opacity-80": i18n.language !== props.locale,
        })}
        type="submit"
        variant="ghost"
      >
        {props.label}
      </Button>
    </fetcher.Form>
  );
}
